import React, { Component } from "react";
import { SERVER_TIMEOUT } from "../constants";
import { SendWSCommand, WSCommandType } from "../types";
import "./Prompts.css";

type VetoPromptProps = {
  sendWSCommand: SendWSCommand;
  electionTracker: number;
  /** Name of the Chancellor who asked for the veto. */
  chancellor?: string;
};

type VetoPromptState = {
  waitingForServer: boolean;
};

class VetoPrompt extends Component<VetoPromptProps, VetoPromptState> {
  timeoutID: NodeJS.Timeout | undefined;

  constructor(props: VetoPromptProps) {
    super(props);
    this.state = {
      waitingForServer: false,
    };
  }

  onButtonClick(accepted: boolean) {
    this.setState({ waitingForServer: true });
    this.timeoutID = setTimeout(
      () => this.setState({ waitingForServer: false }),
      SERVER_TIMEOUT
    );

    this.props.sendWSCommand({
      command: WSCommandType.REGISTER_PRESIDENT_VETO,
      veto: accepted,
    });
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutID);
  }

  render() {
    const chaos = this.props.electionTracker === 2;
    return (
      <div className="pp">
        <div className="pp-kicker">Legislative session · veto</div>
        <div className="pp-title">Accept the veto?</div>
        <div className="pp-text">
          <strong>{this.props.chancellor ? "Chancellor " + this.props.chancellor : "The Chancellor"}</strong> wants to
          veto the agenda. If you refuse, they must enact a policy as normal.
        </div>
        <div className={"pp-note" + (chaos ? " pp-note-danger" : "")}>
          {chaos
            ? "If you accept, the top policy of the draw pile is enacted immediately."
            : "If you accept, both policies are discarded and the election tracker advances by 1."}
        </div>
        <div className="pp-actions">
          <button
            className="pp-btn pp-btn-secondary"
            onClick={() => this.onButtonClick(false)}
            disabled={this.state.waitingForServer}
          >
            REFUSE
          </button>
          <button
            id="prompt-button"
            className="gold-button pp-btn"
            onClick={() => this.onButtonClick(true)}
            disabled={this.state.waitingForServer}
          >
            <span className="gold-label">ACCEPT</span>
          </button>
        </div>
      </div>
    );
  }
}

export default VetoPrompt;
